import { Component, Input, OnInit, NgZone } from '@angular/core';
import { NavController } from '@ionic/angular';

import { Event } from '../../../core/models/events-response';

declare function registerEvent(eventId, time): void;

@Component({
  selector: 'app-event-card',
  templateUrl: './event-card.component.html',
  styleUrls: ['./event-card.component.scss'],
})
export class EventCardComponent implements OnInit {
  @Input()
  event: Event;
  eventTime: String;
  shortLocation: String;
  price: String;

  constructor(private ngZone: NgZone, private navCtrl: NavController) {}

  ngOnInit() {
    this.event = new Event(this.event); //Create actual instance of Event
    this.eventTime = this.event.getEventStartTimeDisplay();
    this.shortLocation = this.event.getLocationDisplay();
    this.price = this.event.getPriceDisplay();
  }

  isImageVisible() {
    return this.event && this.event.thumbnailUrl;
  }

  getBackgroundStyle() {
    const styles = { 'background-image': 'url(' + this.event.thumbnailUrl + ')' };
    return styles;
  }

  checkout(e: MouseEvent) {
    //Prevent click through to anchor element causing redirect to event details page
    e.stopPropagation();
    e.preventDefault();

    var date = new Date();
    var time = date.getTime();

    this.ngZone.runOutsideAngular(() => {
      registerEvent(this.event.eventId, time);
    });
  }
}
